import { useTranslations } from '../../localization/useTranslations';
import { AddressType } from '../types/Address';

export const useAddresses = () => {
  const translations = useTranslations();

  const renderAddressLabelByType = (addressType: AddressType) => {
    switch (addressType) {
      case 'print':
      case 'paper':
        return translations.myAccountSettings.delivery || 'Delivery';

      case 'shop':
        return translations.myAccountSettings.deliveryEshop || 'Delivery e-shop';

      case 'invoice':
        return translations.myAccountSettings.billing || 'Billing';

      default:
        return '';
    }
  };

  const emptyForm = {
    firstName: '',
    lastName: '',
    phoneNumber: '',
    address: '',
    city: '',
    zip: '',
    countryIso: '',
    companyName: '',
    companyId: '',
    taxId: '',
    vatId: '',
  };

  return { renderAddressLabelByType, emptyForm };
};
